import { render, staticRenderFns } from "./textDescDialog.vue?vue&type=template&id=52e82d9b&scoped=true&"
import script from "./textDescDialog.vue?vue&type=script&lang=js&"
export * from "./textDescDialog.vue?vue&type=script&lang=js&"
import style0 from "./textDescDialog.vue?vue&type=style&index=0&id=52e82d9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e82d9b",
  null
  
)

export default component.exports